import {
  TEAMS_SEARCH_CHAT,
  TEAMS_SEARCH_PEOPLE,
  TEAMS_SEARCH_CHANNEL,
  TEAMS_SEARCH_ALL_CATEGORIES,
  CATEGORY_OPTIONS,
  CATEGORY_TO_ABBREVIATION,
} from './src/helpers/constants.js';

export { OmniTeamsSelectionModal } from './src/components/omni-teams-selection-modal.js';
export { AdaptiveCard } from './src/services/adaptive-card.js';
export { MicrosoftAuthenticationHandler } from './src/services/ms-auth-handler.js';

export const constants = {
  TEAMS_SEARCH_CHAT,
  TEAMS_SEARCH_PEOPLE,
  TEAMS_SEARCH_CHANNEL,
  TEAMS_SEARCH_ALL_CATEGORIES,
  CATEGORY_OPTIONS,
  CATEGORY_TO_ABBREVIATION,
};

/* CODEGEN: EXPORT PREPEND (don't remove!) */
// This shouldn't be committed to git with an actual version but it doesn't matter much if you do.
let version = '4.1.0';
if (Number.isNaN(parseInt(version, 10))) {
  version = 'next';
}

// Expose Omni Teams SDK versions as a global
window.omniTeamsSDKVersions = window.omniTeamsSDKVersions || [];
window.omniTeamsSDKVersions.push(version);

// Catch common usage issues
if (window.omniTeamsSDKVersions.length > 1) {
  // eslint-disable-next-line no-console
  console.warn(
    `Omni Teams SDK: found multiple versions
      omni-teams-sdk: (${window.omniTeamsSDKVersions.join(', ')})
    `
  );
}
